module.exports = __webpack_public_path__ + "img/info-exchange-title.74adfc57.png";